import Bugsnag, { Event } from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

const ignoredErrors = [
  // This error usualy says that the request hasn't reached 3rd party API either becuase or network error, CORS, or 3rd party api doesnt exists
  "Network Error",

  // This error is thrown when the request is too long to respond
  "Request failed with status code 414",

  // Weird iframe error...
  "null is not an object (evaluating 'iframe.setAttribute')",

  // This is some weird error in Manes which gets thrown when the iframe is null
  "iframe is null",

  // This error is thrown when the iframe is not loaded yet
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",

  // This error is thrown when the document is not focused and the user tries to copy to clipboard
  "Failed to execute 'writeText' on 'Clipboard': Document is not focused.",
  "Clipboard write was blocked due to lack of user activation.",
];

/*
    Docs: If you want to prevent an event from being sent to BugSnag, you can return false within an onError
*/
function filterErrors(event: Event) {
  const error = event.errors?.[0];
  const stacktrace = error?.stacktrace || [];

  // check if the error message is in the ignored errors array
  if (ignoredErrors.includes(error.errorMessage)) {
    return false;
  }

  if (stacktrace.length > 0 && stacktrace[0].file) {
    // check if the file is in the tinymce plugin folder
    if (
      stacktrace[0].file.includes("assets/tinymce") &&
      !stacktrace[0].file.includes("/visual-merge-tags.js")
    ) {
      return false;
    }
  }

  return true;
}

export function initBugsnag() {
  Bugsnag.start({
    apiKey: import.meta.env.VITE_APP_BUGSNAG_KEY,
    plugins: [new BugsnagPluginVue()],

    onError: filterErrors,
  });

  return Bugsnag.getPlugin("vue");
}
